class OnlyNumbersDirective {
    constructor($timeout, $rootScope) {
        this.restrict = 'A';
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
    }

    link($scope, elem, attrs) {
        attrs.$set('ngTrim', 'false');
        const float = attrs.float;
        elem.bind('keypress', function (e) {
            if (float && e.charCode === 46 && elem[0].value.match(/\./g).length === 0) {
                return true;
            }
            if (e.charCode < 48 || e.charCode > 57) {
                e.preventDefault();
                return false;
            }
        });
    }

    static directiveFactory($timeout, $rootScope) {
        'ngInject';
        return new OnlyNumbersDirective($timeout, $rootScope);
    }
}

export default OnlyNumbersDirective;
